<template>
    <div>
        
    </div>
</template>

<script>
export default {

    data() {
        return {
            
        };
    },

    mounted() {
        window.history.go(-1);
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>

</style>